import { useState, useEffect } from 'react'
import WizrFlexLayout from '../WizrFlexLayout'
import WizrText from '../WizrText'
import { Progress } from 'antd'
import styled from 'styled-components'

const StyledProgressContainer = styled(WizrFlexLayout)`
  gap: 16px;
`

const ProgressBarContainer = styled.div`
  width: 100%;
  margin-top: 8px;
`

const ProgressInfo = styled(WizrFlexLayout)`
  justify-content: space-between;
  width: 100%;
  margin-top: 8px;
`

const ImportWorkflowProgress = ({ onComplete, onError, importPromise }: any): JSX.Element => {
  const [progress, setProgress] = useState(0)
  const [estimatedTime, setEstimatedTime] = useState(2) // in minutes

  useEffect(() => {
    let progressInterval: NodeJS.Timeout
    let timeInterval: NodeJS.Timeout

    // Simulate progress updates
    progressInterval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 90) {
          return 90
        }
        const increment = Math.random() * 2 + 1
        return Math.min(prev + increment, 90)
      })
    }, 800)

    timeInterval = setInterval(() => {
      setEstimatedTime((prev) => {
        const currentProgress = progress
        if (currentProgress >= 90) return 0
        const remaining = Math.max(0, Math.ceil((100 - currentProgress) / 50))
        return remaining
      })
    }, 1000)

    if (importPromise) {
      importPromise
        .then((response: any) => {
          clearInterval(progressInterval)
          clearInterval(timeInterval)
          setProgress(100)
          setEstimatedTime(0)
          setTimeout(() => {
            if (onComplete) onComplete(response)
          }, 500)
        })
        .catch((error: any) => {
          clearInterval(progressInterval)
          clearInterval(timeInterval)
          if (onError) {
            onError(error)
          }
        })
    }

    return () => {
      if (progressInterval) clearInterval(progressInterval)
      if (timeInterval) clearInterval(timeInterval)
    }
  }, [importPromise, onComplete, onError])

  return (
    <StyledProgressContainer flexDirection="column" background="#FFF">
      <WizrText type="sub1" textColor="#1D1F22" style={{ marginBottom: '8px' }}>
        Importing Workflow
      </WizrText>
      <WizrText type="body2" textColor="#5D5F62" style={{ marginBottom: '16px' }}>
        We're setting up your workflow by validating configurations and preparing the execution environment. This may take a moment.
      </WizrText>
      <ProgressBarContainer>
        <Progress
          percent={Math.round(progress)}
          strokeColor="#14B8A6"
          trailColor="#E5E7EB"
          showInfo={false}
          strokeWidth={8}
        />
      </ProgressBarContainer>
      <ProgressInfo flexDirection="row" background="#FFF">
        <WizrText type="caption2" textColor="#5D5F62">
          Estimated time remaining: {estimatedTime} {estimatedTime === 1 ? 'min' : 'mins'}
        </WizrText>
        <WizrText type="caption2" textColor="#5D5F62">
          {Math.round(progress)}%
        </WizrText>
      </ProgressInfo>
    </StyledProgressContainer>
  )
}

export default ImportWorkflowProgress
